import { get } from "./utils.service";

export const getUsers = async () => {
  return await get("/admin/users");
};

export const getUserLastMessages = async (userId) => {
  return await get(`/admin/user-last-messages?userId=${userId}`);
};
